import {required} from "vuelidate/lib/validators";  
const StrBirimKontrolTutarlari = {
    data() {
      return { 
        StrBirimKontrolTutarlariData:{ 
          Donem:"",
          Tutar:"", 
          BirimId:null, 
          HarcamaTipId:"", 
          Deleted: false 
        },   
          FormDataType:{ 
            Donem:{FieldName:"Donem",Field:"combobox",FieldTitle:this.$t('StrBirimKontrolTutarlari.AddEdit.Donem'),ComboDataArray:[]}, 
            BirimId:{FieldName:"BirimId",Field:"combobox",FieldTitle:this.$t('StrBirimKontrolTutarlari.AddEdit.BirimId')},
            HarcamaTipId:{FieldName:"HarcamaTipId",Field:"combobox",FieldTitle:this.$t('StrBirimKontrolTutarlari.AddEdit.HarcamaTipId'),ComboDataArray:[]},
            Tutar:{FieldName:"Tutar",Field:"input",FieldTitle:this.$t('StrBirimKontrolTutarlari.AddEdit.Tutar'),FieldType:"number"},  
          }  ,

          Yillar:[
            {"id":"2021","value":"2021"},
            {"id":"2022","value":"2022"},
            {"id":"2023","value":"2023"},
            {"id":"2024","value":"2024"},
            {"id":"2025","value":"2025"},
            {"id":"2026","value":"2026"},
            {"id":"2027","value":"2027"},
            {"id":"2028","value":"2028"},
            {"id":"2029","value":"2029"},
            {"id":"2030","value":"2030"},

          ] 
      }
    },
    validations:{ 
          FormData: {
            Donem: { required }, 
            Tutar: { required }, 
            BirimId: { required },  
            HarcamaTipId: { required },  
        },
    DusumYapilacakMi:{},
    DusumYapilacakBirim:{}
  }, 
  created(){ 
   

    this.FormDataType.Donem.ComboDataArray=[];
    for (var i=0 ; i<this.Yillar.length; i++){
      this.FormDataType.Donem.ComboDataArray.push ({Id:this.Yillar[i].id,Value:this.Yillar[i].value})
    }


    this.ActionsSabitGet(1548).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.HarcamaTipId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
        }    
    }); 
    this.ActionsSabitGet(1552).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.IhaleTipiId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
        }    
    });
    this.ActionsSabitGet(77).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.Ay.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
        }    
    });
    
  }
}
export default StrBirimKontrolTutarlari